var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4011_49047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 0C28.7 0 0 28.7 0 64C0 99.3 28.7 128 64 128C99.3 128 128 99.3 128 64C128 28.7 99.3 0 64 0ZM49.5 37.1C49.5 36 50.8 34.5 51.8 34C62.5 28.9 73.4 24 84.1 19C88.3 17.1 92.3 17.6 95.7 20.7C99.6 24.4 103.4 28.2 107.1 32.2C107.9 33 108 34.6 108.4 35.8C107.3 36.1 106.2 36.4 105 36.7C102.8 37.2 100.5 37.4 98.5 38.4C83.7 45.4 68.9 52.7 54 59.8C52.7 60.4 51.5 60.9 49.4 61.9C49.4 53 49.3 45.1 49.5 37.1ZM100.6 85.1C95.6 85.3 90.6 85.3 85.7 85.1C84.6 85 83 84 82.5 82.9C77.9 74.1 73.5 65.2 68.8 55.8C76.2 52.2 83.1 48.9 90.4 45.3C95.8 55.7 101.3 65.7 106.3 76C108.4 80.3 105.5 84.8 100.6 85.1ZM28.6 23.6C34.2 19 40 14.9 47.1 13.3C47.1 37.6 47.1 61.1 47.1 84.9C39.1 84.9 31.7 84.9 23.7 84.9C23.7 83.4 23.7 82 23.7 80.5C23.7 65.1 23.8 49.8 23.7 34.4C23.7 29.9 25.2 26.4 28.6 23.6ZM82 110.2C76 110.2 70.1 110.2 64.1 110.2C58.3 110.2 52.4 109.8 46.6 110.3C38.1 111 31.4 107.5 25.9 101C23.1 97.6 20.4 94.1 17.8 90.5C17.2 89.7 17.2 88.2 17.5 87.3C17.6 86.9 19.2 86.8 20.1 86.9C22.6 87.1 25.1 87.7 27.7 87.7C51.7 87.8 75.8 87.8 99.8 87.7C102.6 87.7 105.4 87.1 108.2 86.8C109 86.7 110.3 86.8 110.5 87.2C110.9 88 110.9 89.3 110.6 90.1C106.4 100.9 93.1 110.2 82 110.2Z",
    fill: "#5B5176"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4011_49047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKk);
export default __webpack_public_path__ + "static/media/kk - ธนาคารเกียรตินาคิน.be201260d832fe097bb45de3c172e071.svg";
export { ForwardRef as ReactComponent };